var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJaquarLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_101",
    "data-name": "Group 101",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 160.995,
    height: 35.791,
    viewBox: "0 0 160.995 35.791",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_467",
    "data-name": "Rectangle 467",
    width: 160.995,
    height: 35.791
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_100",
    "data-name": "Group 100",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M121.064,32.067c.638-.307,2.476-1.159,3.3-1.526-.092.4-.184.8-.281,1.2-.232.958-.491,2.05-.76,3.179-.479,2.016-.974,4.1-1.4,5.788-.664,2.632-1.425,5.325-2.035,7.2a5.474,5.474,0,0,1-4.352,3.885,28.545,28.545,0,0,1-5.046.281c1.308-1.217,2.644-2.83,2.887-3.022l.318-.018a4.515,4.515,0,0,0,2.127-.471,3.1,3.1,0,0,0,1.411-1.877c.481-1.981,1.153-4.435,1.755-6.807.57-2.244,1.158-4.564,1.618-6.448l.315-1.295Z",
    transform: "translate(-84.697 -23.412)",
    fill: "#09565f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M378.317,39.521a23,23,0,0,0-4.3.182,5.687,5.687,0,0,0-4.521,4.035c-.634,1.95-1.751,6.579-1.993,7.575-.1.414-.132.679-.227,1.094h3.185s1.241-5.341,1.741-7.4a2.781,2.781,0,0,1,1.337-1.821,6.033,6.033,0,0,1,1.743-.412Z",
    transform: "translate(-281.546 -30.279)",
    fill: "#09565f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M228.141,40.2a4.9,4.9,0,0,0-4.054.022,8.661,8.661,0,0,0-5.092,8.858,3.666,3.666,0,0,0,3.289,3.431c.605.057,1.184.046,1.856.054l.3-.015c.037-.013.058-.149.131-.45.063-.263.521-2.2.669-2.842l.1-.415h-.005c-.239.061-.459.118-.681.163a2.16,2.16,0,0,1-1.724-.319,1.668,1.668,0,0,1-.663-1.208,3.807,3.807,0,0,1,1.647-3.7,2.263,2.263,0,0,1,2.541-.093c1.1.672.72,2.1.487,3.116q-.27,1.179-.545,2.357c-.227.963-.551,2.049-.865,3.1-.306,1.027-.624,2.088-.846,3.023l-.739,3.112s3.384-2.007,3.548-2.108l.09-.374c.3-1.265.693-2.643,1.071-3.977.446-1.572.907-3.2,1.235-4.678a16.574,16.574,0,0,0,.486-3.424,3.75,3.75,0,0,0-2.231-3.632",
    transform: "translate(-167.836 -30.491)",
    fill: "#09565f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M177.6,43.584a4,4,0,0,0-1.286-2.782c-.051-.045-.1-.089-.156-.132a4.119,4.119,0,0,0-2.642-.952,5.993,5.993,0,0,0-2.209.471,8.615,8.615,0,0,0-5.154,8.267,4.245,4.245,0,0,0,1.332,3.136,4.173,4.173,0,0,0,2.806.96l0,0c.332.007.671.007,1.039.012l.317-.015c.017-.006.9-3.748.9-3.748-.231.057-.448.111-.665.157a2.156,2.156,0,0,1-1.751-.319,1.716,1.716,0,0,1-.676-1.271,3.8,3.8,0,0,1,1.457-3.466,3.012,3.012,0,0,1,1.4-.552,1.857,1.857,0,0,1,1.5.371,1.9,1.9,0,0,1,.592,1.468,4.82,4.82,0,0,1-.058.761c-.024.167-.055.337-.1.513q-.313,1.35-.638,2.7-.131.55-.263,1.1l-.432,1.988c-.021.09-.037.181-.054.278h3.018l1.276-5.524q.026-.1.05-.209a11.368,11.368,0,0,0,.415-2.779c0-.145-.008-.29-.021-.435",
    transform: "translate(-127.366 -30.448)",
    fill: "#09565f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M331.052,43.584a4,4,0,0,0-1.286-2.782c-.05-.045-.1-.089-.156-.132a4.118,4.118,0,0,0-2.642-.952,6,6,0,0,0-2.209.471,8.615,8.615,0,0,0-5.154,8.267,4.245,4.245,0,0,0,1.332,3.136,4.172,4.172,0,0,0,2.806.96l0,0c.332.007.671.007,1.04.012l.317-.015c.017-.006.9-3.748.9-3.748-.231.057-.448.111-.665.157a2.156,2.156,0,0,1-1.751-.319,1.715,1.715,0,0,1-.676-1.271,3.794,3.794,0,0,1,1.457-3.466,3.01,3.01,0,0,1,1.4-.552,1.857,1.857,0,0,1,1.5.371,1.9,1.9,0,0,1,.591,1.468,4.789,4.789,0,0,1-.057.761c-.025.167-.055.337-.1.513q-.313,1.35-.638,2.7l-.263,1.1-.432,1.988c-.021.09-.037.181-.053.278h3.018l1.276-5.524.05-.209a11.389,11.389,0,0,0,.415-2.779c0-.145-.009-.29-.021-.435",
    transform: "translate(-244.999 -30.448)",
    fill: "#09565f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M281.973,40.26c-.743,0-1.464.017-2.183.005h-.008c-.224,0-.236-.013-.247.026s.005-.011-.048.215c-.555,2.341-1.125,4.888-1.629,6.951a2.752,2.752,0,0,1-1.649,2.041,1.7,1.7,0,0,1-1.748-.181,1.6,1.6,0,0,1-.492-1.6c.241-1.227,1.682-7.439,1.682-7.439h-3.034s-1.032,4.529-1.365,5.9a10.556,10.556,0,0,0-.452,3.317A3.669,3.669,0,0,0,271.917,52a4.04,4.04,0,0,0,4.642.605,6.733,6.733,0,0,0,2.033-1.275c.065-.06.127-.122.19-.184.032-.032.066-.062.1-.094a7.955,7.955,0,0,0,1.741-2.895q.078-.217.148-.444c.4-1.282.71-2.617,1.014-3.908.13-.555.68-2.888.788-3.35l.051-.189Z",
    transform: "translate(-207.576 -30.862)",
    fill: "#09565f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M18.854,3.819A52.737,52.737,0,0,0,22.812,0c-.318,1.1-.684,2.461-1.144,4.369q-.5,2.058-.989,4.118c-1.461,6.088-2.723,12.385-5.089,17.989C11.78,35.506.582,35.786.582,35.786,7.765,32.968,12.263,27.653,13.8,22.461c1.807-6.123,3.39-12.37,5.041-18.57Z",
    transform: "translate(-0.446 -0.001)",
    fill: "#09565f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M16.229,23.115c-.273.889-.583,2.319-.994,3.865-.3,1.112-.522,1.935-.816,3.048-1.305,4.936-2.488,10.041-4.377,14.588A15.44,15.44,0,0,1,0,53.511c5-2.7,7.56-7.715,8.866-11.925,1.54-4.966,2.839-10.472,4.278-15.5l.015-.059a38.954,38.954,0,0,0,3.069-2.911",
    transform: "translate(0 -17.719)",
    fill: "#09565f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M476.27,64.261c.124,0,.258,0,.4,0s.285.011.426.024a3.374,3.374,0,0,1,.393.061,1.014,1.014,0,0,1,.312.122,1.513,1.513,0,0,1,.483.471,1.308,1.308,0,0,1,.2.739,1.409,1.409,0,0,1-.224.8,1.313,1.313,0,0,1-.637.5V67a1.331,1.331,0,0,1,.819.487,1.455,1.455,0,0,1,.284.909,1.721,1.721,0,0,1-.114.616,1.545,1.545,0,0,1-.336.532,1.7,1.7,0,0,1-.553.373,1.9,1.9,0,0,1-.758.142h-2.8V64.261Zm.211,2.491a1.518,1.518,0,0,0,.945-.232.834.834,0,0,0,.289-.693,1.022,1.022,0,0,0-.1-.487.694.694,0,0,0-.268-.277,1.058,1.058,0,0,0-.394-.125,3.759,3.759,0,0,0-.475-.028h-1.541v1.842Zm.39,2.654a1.11,1.11,0,0,0,.8-.276,1.007,1.007,0,0,0,.288-.763.944.944,0,0,0-.106-.471.83.83,0,0,0-.28-.3,1.173,1.173,0,0,0-.4-.154,2.41,2.41,0,0,0-.471-.044h-1.761v2Z",
    transform: "translate(-363.488 -49.261)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M498.168,64.261l2.264,5.793h-.852l-.633-1.745H496.5l-.649,1.745h-.788l2.256-5.793Zm.536,3.4-.965-2.7h-.017l-.982,2.7Z",
    transform: "translate(-379.503 -49.261)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M514.67,64.911v-.649H519.3v.649h-1.931v5.145H516.6V64.911Z",
    transform: "translate(-394.535 -49.262)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M538.034,64.261v2.491h3.052V64.261h.77v5.793h-.77V67.4h-3.052v2.653h-.771V64.261Z",
    transform: "translate(-411.855 -49.261)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M570.146,69.654v.552h-1.769v1.777h-.552V70.205h-1.77v-.552h1.77V67.877h.552v1.777Z",
    transform: "translate(-433.928 -52.033)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M593.466,64.261v5.145h3.067v.649H592.7V64.261Z",
    transform: "translate(-454.348 -49.261)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_465",
    "data-name": "Rectangle 465",
    width: 0.77,
    height: 5.793,
    transform: "translate(142.891 15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M623.58,69.533a2.743,2.743,0,0,1-1.014.2,2.712,2.712,0,0,1-1.16-.239,2.632,2.632,0,0,1-.868-.645,2.816,2.816,0,0,1-.544-.933,3.258,3.258,0,0,1-.187-1.095,4.133,4.133,0,0,1,.174-1.205,2.984,2.984,0,0,1,.52-1,2.534,2.534,0,0,1,.86-.685,2.684,2.684,0,0,1,1.205-.255,3.5,3.5,0,0,1,.888.109,2.242,2.242,0,0,1,.746.345,2.043,2.043,0,0,1,.552.6,2.357,2.357,0,0,1,.3.872h-.771a1.527,1.527,0,0,0-.211-.571,1.361,1.361,0,0,0-.382-.394,1.681,1.681,0,0,0-.515-.232,2.362,2.362,0,0,0-.612-.077,1.763,1.763,0,0,0-1.522.766,2.441,2.441,0,0,0-.353.788,3.649,3.649,0,0,0-.113.9,2.923,2.923,0,0,0,.13.873,2.274,2.274,0,0,0,.381.739,1.865,1.865,0,0,0,.621.511,1.831,1.831,0,0,0,.856.191,2.083,2.083,0,0,0,.8-.146,1.686,1.686,0,0,0,.588-.4,1.705,1.705,0,0,0,.361-.6,1.987,1.987,0,0,0,.106-.743h-1.851v-.649h2.54V69.6h-.486l-.2-.722a1.931,1.931,0,0,1-.844.653",
    transform: "translate(-475.132 -48.809)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M648.182,64.261v2.491h3.051V64.261H652v5.793h-.771V67.4h-3.051v2.653h-.771V64.261Z",
    transform: "translate(-496.292 -49.261)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M669.867,64.911v-.649H674.5v.649H672.57v5.145h-.77V64.911Z",
    transform: "translate(-513.507 -49.262)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_466",
    "data-name": "Rectangle 466",
    width: 0.209,
    height: 21.527,
    transform: "translate(103.595 7.129)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJaquarLogo);
export default __webpack_public_path__ + "static/media/JaquarLogo.8dbd570b0c14aed79504465f457f3b57.svg";
export { ForwardRef as ReactComponent };